import { createContext, useContext } from 'react';

import { ICartEntry } from '@rbi-ctg/menu';

type MenuLayoutContextType = {
  onUpdate: (cartEntry: ICartEntry) => void;
  isEditingThisItem: boolean;
  addText: string;
};

const menuLayoutContext = createContext<MenuLayoutContextType | null>(null);

export const MenuLayoutProvider = menuLayoutContext.Provider;

export function useMenuLayout() {
  const context = useContext(menuLayoutContext);

  if (!context) {
    throw new Error('Must consume `useMenuLayout` with a MenuLayoutProvider');
  }

  return context;
}
